<template>
  <SrpModal :isVisible="props.isVisible" @update:isVisible="isVisible => emit('update:isVisible', isVisible)">
    <template #content>
      <div class="edit-calendar-form">
        <h1 class="global-h1 edit-calendar-form__title">Delete and Regen?</h1>
        <!--<div class="edit-calendar-form__subtitle">Give some guidance on what's off, and the AI will try again</div>-->

        <NoteWithIcon style="margin-top: 20px">
          <template #icon>
            <IconEmbedded name="warning_2" :size="26" style="position: relative; top: -2px" />
          </template>
          <template #text>
            <b
              >Deletes and re-generates calendar Topics, including those added manually.<br />
              Note: It will NOT delete Topics that have approved posts.</b
            >
          </template>
        </NoteWithIcon>

        <NoteWithIcon v-if="!isTestMode" color="red" style="margin-top: 15px">
          <template #text>
            <b>Warning: This will delete Posts from a Live calendar!</b>
          </template>
        </NoteWithIcon>

        <!--<textarea class="global-textarea edit-calendar-form__textarea" v-model="guidanceText" placeholder="Guidance: TODO!!! Not wired up yet"></textarea>-->
      </div>
    </template>

    <template #footer="{ closeModal }">
      <SrpButton color="gray" fill="outlined" @click="closeModal">Cancel</SrpButton>

      <SrpButton
        class="edit-calendar-form__action-button"
        @click="
          () => {
            emit('regenerate', guidanceText);
            closeModal();
          }
        "
      >
        <template #icon><IconEmbedded name="reload_2-5" :size="22" /></template>
        Regenerate
      </SrpButton>
    </template>
  </SrpModal>
</template>

<script setup lang="ts">
import { ref } from "vue";
import { useCalendarTestModeManager } from "@logic/calendarTestModeManager";

// Components
import SrpButton from "@components/ui/SrpButton.vue";
import IconEmbedded from "@components/ui/IconEmbedded.vue";
import NoteWithIcon from "@components/NoteWithIcon.vue";
import SrpModal from "@components/ui/SrpModal.vue";

const props = withDefaults(
  defineProps<{
    isVisible: boolean;
  }>(),
  {}
);

const emit = defineEmits<{
  (e: "regenerate", guidanceText: string): void;
  (e: "update:isVisible", isVisible: boolean): void;
}>();

// Test mode check ============================================================
const { isTest: isTestMode } = useCalendarTestModeManager();

// Guidance text ==============================================================
const guidanceText = ref<string>("");
</script>

<style scoped lang="scss">
@import "@/scss/variables.scss";

// Edit calendar form =========================================================
.edit-calendar-form {
  @include standardFont;

  &__title {
    margin-bottom: 2px;

    &--disabled {
      opacity: 0.4;
      pointer-events: none;
    }
  }

  &__subtitle {
    margin-bottom: 13px;

    &--disabled {
      opacity: 0.4;
      pointer-events: none;
    }
  }

  &__textarea {
    min-height: 115px;
    margin-bottom: 16px;
  }

  &__action-button {
  }
}
</style>
